const readingTime = count => {
  const wordPerMinute = 250;
  const words = count;
  const time = Math.ceil(words / wordPerMinute);
  return `${time} minute read`;
};

export default readingTime;
